<template>
  <ModalWindow
    v-model:visible="localValue"
    data-testid="modal-confirm"
    class="modal-confirm"
    :class="{'text-center': textCenter}"
    backdrop-close
    :show-title="false"
    :max-width="maxWidth"
    filled-close-icon
    @on-close="close"
  >
    <div
      v-if="isIcon"
      class="modal-confirm__icon"
      :class="`modal-confirm__icon--${type}`"
    >
      <IconCloseRound v-if="type === 'danger'" />
      <IconCheckCircle v-if="type === 'primary'" />
    </div>
    <h3
      v-if="!!text && !title"
      class="modal-confirm__title"
    >
      {{ text }}
    </h3>

    <template v-else-if="!!text && !!title">
      <h3 class="modal-confirm__title">
        {{ title }}
      </h3>
      <div class="modal-confirm__text">
        {{ text }}
      </div>
    </template>

    <div v-if="text && !title" />

    <template #footer>
      <ModalWindowNavigation :has-equal-two-columns="true">
        <BaseButton
          :type="type"
          uppercase
          @click="confirm"
        >
          {{ textOk.toUpperCase() }}
        </BaseButton>
        <BaseButton
          type="outline"
          class="text-capitalize"
          @click="cancel"
        >
          {{ textCancel.toUpperCase() }}
        </BaseButton>
      </ModalWindowNavigation>
    </template>
  </ModalWindow>
</template>

<script>
import ModalWindow from '@/components/modals/ModalWindow.vue'
import BaseButton from '@/components/button/BaseButton.vue'
import IconCloseRound from '@/components/icons/IconCloseRound.vue'
import IconCheckCircle from '@/components/icons/IconCheckCircle.vue'
import ModalWindowNavigation from '@/components/modals/ModalWindowNavigation.vue'
import { LocalValueMixin } from '@/mixins/localValue.mixin.js'

export default {
  name: 'ModalConfirm',
  components: {
    ModalWindowNavigation,
    ModalWindow,
    BaseButton,
    IconCloseRound,
    IconCheckCircle
  },
  mixins: [LocalValueMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    isIcon: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'primary',
      validator(item) {
        return ['primary', 'danger'].includes(item)
      }
    },
    textOk: {
      type: String,
      default: ''
    },
    textCancel: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: Number,
      default: null
    },
    textCenter: {
      type: Boolean,
      default: true
    }
  },
  emits: ['confirm', 'cancel'],
  methods: {
    confirm() {
      this.localValue = false
      this.$emit('confirm')
    },
    cancel() {
      this.localValue = false
      this.$emit('cancel')
    },
    close() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-confirm {
  .modal-confirm__icon {
    svg {
      width: 100px;
      height: 100px;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    margin: var(--space-32) 0 var(--space-20);
    color: var(--color-red-600);
  }

  .modal-confirm__icon--primary {
    color: var(--color-green-600);
  }

  .modal-confirm__icon--danger {
    color: var(--color-red-600);
  }

  .modal-confirm__title {
    margin-top: 0;
    margin-bottom: var(--space-20);
    font-size: var(--space-20);
    font-weight: var(--weight-normal);
    white-space: pre-wrap;
    word-break: break-all;
  }

  .modal-confirm__text {
    color: var(--color-zinc-400);
    font-size: var(--font-size-body-1);
    line-height: var(--leading-180);
    font-weight: var(--weight-normal);
  }
}
</style>
